import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { TableConfig } from "../../../../types/table";
import { Table } from "../../../shared/ui/Table";
import { ChartData } from "../RankifierChart";

import styles from "./RawScoresTable.module.scss";

export const RawScoresTable = ({ data }: { data: ChartData[] }) => {
  const { t } = useTranslation();

  const tableConfig = useMemo<TableConfig<ChartData>>(
    () => ({
      headerClassName: styles.tableHeader,
      rowClassName: styles.tableRow,
      columns: [
        {
          header: t("report:rankifier:table.attribute"),
          render: ({ name }) => <>{name}</>,
        },
        {
          header: t("report:rankifier:table.negatives"),
          render: ({ negatives }) => <>{negatives}</>,
        },
        {
          header: t("report:rankifier:table.positives"),
          render: ({ positives }) => <>{positives}</>,
        },
      ],
    }),
    [],
  );

  return <Table data={data} config={tableConfig} className={styles.rawScoresTable} />;
};
